import { render, staticRenderFns } from "./TemplateBaseForm.vue?vue&type=template&id=cc469116"
import script from "./TemplateBaseForm.vue?vue&type=script&lang=js"
export * from "./TemplateBaseForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateBaseForm.vue?vue&type=style&index=0&id=cc469116&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports